import React from 'react';

export const LikeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9166 9.99992C17.9166 14.3722 14.3722 17.9166 9.99992 17.9166C5.62766 17.9166 2.08325 14.3722 2.08325 9.99992C2.08325 5.62766 5.62766 2.08325 9.99992 2.08325C14.3722 2.08325 17.9166 5.62766 17.9166 9.99992ZM19.1666 9.99992C19.1666 15.0625 15.0625 19.1666 9.99992 19.1666C4.93731 19.1666 0.833252 15.0625 0.833252 9.99992C0.833252 4.93731 4.93731 0.833252 9.99992 0.833252C15.0625 0.833252 19.1666 4.93731 19.1666 9.99992ZM7.29647 7.44167C7.29647 6.86637 6.8301 6.4 6.2548 6.4C5.6795 6.4 5.21313 6.86637 5.21313 7.44167V8.44167C5.21313 9.01696 5.6795 9.48333 6.2548 9.48333C6.8301 9.48333 7.29647 9.01696 7.29647 8.44167V7.44167ZM13.7416 6.4C14.3169 6.4 14.7833 6.86637 14.7833 7.44167V8.44167C14.7833 9.01696 14.3169 9.48333 13.7416 9.48333C13.1663 9.48333 12.7 9.01696 12.7 8.44167V7.44167C12.7 6.86637 13.1663 6.4 13.7416 6.4ZM6.77309 11.4152C7.01576 11.1979 7.38859 11.2184 7.60599 11.4609L7.61285 11.4684C7.61971 11.4757 7.63111 11.4878 7.64681 11.5039C7.67825 11.5362 7.7267 11.5844 7.79027 11.6433C7.91798 11.7616 8.10352 11.9199 8.33185 12.0776C8.79974 12.4008 9.3893 12.6814 10 12.6814C10.6107 12.6814 11.2003 12.4008 11.6681 12.0776C11.8965 11.9199 12.082 11.7616 12.2097 11.6433C12.2733 11.5844 12.3217 11.5362 12.3532 11.5039C12.3689 11.4878 12.3803 11.4757 12.3871 11.4684L12.3943 11.4606C12.6117 11.2184 12.9843 11.198 13.2269 11.4152C13.4697 11.6326 13.49 12.0059 13.2726 12.2486C13.2727 12.2485 13.2729 12.2483 12.8449 11.8651L13.2726 12.2486L13.2717 12.2497L13.27 12.2515L13.2653 12.2567L13.2503 12.273C13.2378 12.2864 13.2204 12.3047 13.1984 12.3274C13.1543 12.3726 13.0914 12.435 13.0116 12.5089C12.8526 12.6563 12.6232 12.8521 12.3388 13.0485C11.7812 13.4337 10.9541 13.8614 10 13.8614C9.04589 13.8614 8.21878 13.4337 7.66121 13.0485C7.3768 12.8521 7.14742 12.6563 6.98838 12.5089C6.90857 12.435 6.84569 12.3726 6.80165 12.3274C6.77961 12.3047 6.76222 12.2864 6.74974 12.273L6.73469 12.2567L6.72996 12.2515L6.72831 12.2497L6.72712 12.2483L7.16667 11.8548C6.72712 12.2483 6.727 12.2482 6.72712 12.2483C6.50976 12.0056 6.53034 11.6326 6.77309 11.4152Z"
      fill="var(--col_text02)"
    />
  </svg>
);

export const LikeIconActiveWeb = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <circle cx="10.0007" cy="10.5007" r="9.16667" fill="url(#paint0_linear_772_2114)" />
    <path
      d="M7.16602 12.25C7.16602 12.25 8.43454 13.5 9.99935 13.5C11.5642 13.5 12.8327 12.25 12.8327 12.25"
      stroke="#222222"
      strokeWidth="1.18"
      strokeLinecap="round"
    />
    <path
      d="M6.25391 7.66992V8.66992"
      stroke="#222222"
      strokeWidth="2.08333"
      strokeLinecap="round"
    />
    <path
      d="M13.7422 7.66992V8.66992"
      stroke="#222222"
      strokeWidth="2.08333"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_772_2114"
        x1="10.0007"
        y1="1.33398"
        x2="10.0007"
        y2="19.6673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7E49" />
        <stop offset="1" stopColor="#FFDD75" />
      </linearGradient>
    </defs>
  </svg>
);

export const UnLikeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9167 10.0002C17.9167 14.3724 14.3723 17.9168 10 17.9168C5.62779 17.9168 2.08337 14.3724 2.08337 10.0002C2.08337 5.62791 5.62779 2.0835 10 2.0835C14.3723 2.0835 17.9167 5.62791 17.9167 10.0002ZM19.1667 10.0002C19.1667 15.0628 15.0626 19.1668 10 19.1668C4.93743 19.1668 0.833374 15.0628 0.833374 10.0002C0.833374 4.93755 4.93743 0.833496 10 0.833496C15.0626 0.833496 19.1667 4.93755 19.1667 10.0002ZM8.32396 7.68163C8.5599 7.44569 8.5599 7.06315 8.32396 6.82721C8.08801 6.59127 7.70548 6.59127 7.46954 6.82721L6.71821 7.57854L5.96695 6.82728C5.73101 6.59134 5.34847 6.59134 5.11253 6.82728C4.87659 7.06322 4.87659 7.44576 5.11253 7.6817L5.86379 8.43296L5.11251 9.18423C4.87657 9.42017 4.87657 9.80271 5.11251 10.0387C5.34845 10.2746 5.73099 10.2746 5.96693 10.0387L6.71821 9.28738L7.46955 10.0387C7.70549 10.2747 8.08803 10.2747 8.32397 10.0387C8.55992 9.80278 8.55992 9.42025 8.32397 9.1843L7.57263 8.43296L8.32396 7.68163ZM14.8843 7.68163C15.1202 7.44569 15.1202 7.06315 14.8843 6.82721C14.6483 6.59127 14.2658 6.59127 14.0298 6.82721L13.2785 7.57854L12.5273 6.82728C12.2913 6.59134 11.9088 6.59134 11.6728 6.82728C11.4369 7.06322 11.4369 7.44576 11.6728 7.6817L12.4241 8.43296L11.6728 9.18423C11.4369 9.42017 11.4369 9.80271 11.6728 10.0387C11.9088 10.2746 12.2913 10.2746 12.5272 10.0387L13.2785 9.28738L14.0299 10.0387C14.2658 10.2747 14.6483 10.2747 14.8843 10.0387C15.1202 9.80278 15.1202 9.42025 14.8843 9.1843L14.1329 8.43296L14.8843 7.68163ZM6.7731 13.6109C7.01577 13.8281 7.3886 13.8077 7.606 13.5651L7.61287 13.5577C7.61973 13.5504 7.63113 13.5383 7.64683 13.5222C7.67827 13.4899 7.72672 13.4417 7.79029 13.3828C7.918 13.2645 8.10354 13.1061 8.33187 12.9484C8.79976 12.6252 9.38932 12.3446 10 12.3446C10.6107 12.3446 11.2003 12.6252 11.6682 12.9484C11.8965 13.1061 12.082 13.2645 12.2097 13.3828C12.2733 13.4417 12.3218 13.4899 12.3532 13.5222C12.3689 13.5383 12.3803 13.5504 12.3872 13.5577L12.394 13.5651L12.3947 13.5659C12.6122 13.8077 12.9845 13.8279 13.2269 13.6109C13.4697 13.3935 13.49 13.0202 13.2726 12.7775L13.2717 12.7764L13.2701 12.7746L13.2653 12.7694L13.2503 12.7531C13.2378 12.7397 13.2204 12.7213 13.1984 12.6987C13.1543 12.6535 13.0914 12.5911 13.0116 12.5171C12.8526 12.3698 12.6232 12.174 12.3388 11.9775C11.7812 11.5924 10.9541 11.1646 10 11.1646C9.04591 11.1646 8.2188 11.5924 7.66123 11.9775C7.37682 12.174 7.14743 12.3698 6.98839 12.5171C6.90859 12.5911 6.84571 12.6535 6.80166 12.6987C6.77962 12.7213 6.76224 12.7397 6.74976 12.7531L6.73471 12.7694L6.72998 12.7746L6.72832 12.7764L6.72714 12.7777C6.50978 13.0205 6.53035 13.3935 6.7731 13.6109ZM7.16668 13.1713C6.72714 12.7777 6.72701 12.7779 6.72714 12.7777L7.16668 13.1713ZM12.8333 13.1713L13.2726 12.7775C13.2728 12.7776 13.2729 12.7777 12.8333 13.1713Z"
      fill="var(--col_text02)"
    />
  </svg>
);

export const UnLikeIconActiveWeb = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <circle cx="10.0007" cy="10.5007" r="9.16667" fill="url(#paint0_linear_772_18349)" />
    <path
      d="M7.16602 13.334C7.16602 13.334 8.43454 12.084 9.99935 12.084C11.5642 12.084 12.8327 13.334 12.8327 13.334"
      stroke="#222222"
      strokeWidth="1.18"
      strokeLinecap="round"
    />
    <path
      d="M7.89648 7.58301L5.53946 9.94003"
      stroke="#222222"
      strokeWidth="1.20833"
      strokeLinecap="round"
    />
    <path
      d="M5.53906 7.58301L7.89609 9.94003"
      stroke="#222222"
      strokeWidth="1.20833"
      strokeLinecap="round"
    />
    <path
      d="M14.457 7.58301L12.1 9.94003"
      stroke="#222222"
      strokeWidth="1.20833"
      strokeLinecap="round"
    />
    <path
      d="M12.0996 7.58301L14.4566 9.94003"
      stroke="#222222"
      strokeWidth="1.20833"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_772_18349"
        x1="10.0007"
        y1="1.33398"
        x2="10.0007"
        y2="19.6673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5757" />
        <stop offset="1" stopColor="#FFB46D" />
      </linearGradient>
    </defs>
  </svg>
);

export const SameIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17.9166C14.3723 17.9166 17.9167 14.3722 17.9167 9.99992C17.9167 5.62766 14.3723 2.08325 10 2.08325C5.62779 2.08325 2.08337 5.62766 2.08337 9.99992C2.08337 14.3722 5.62779 17.9166 10 17.9166ZM10 19.1666C15.0627 19.1666 19.1667 15.0625 19.1667 9.99992C19.1667 4.93731 15.0627 0.833252 10 0.833252C4.93743 0.833252 0.833374 4.93731 0.833374 9.99992C0.833374 15.0625 4.93743 19.1666 10 19.1666Z"
      fill="var(--col_text02)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25492 6.3999C6.83022 6.3999 7.29659 6.86627 7.29659 7.44157V8.44157C7.29659 9.01687 6.83022 9.48324 6.25492 9.48324C5.67963 9.48324 5.21326 9.01687 5.21326 8.44157V7.44157C5.21326 6.86627 5.67963 6.3999 6.25492 6.3999Z"
      fill="var(--col_text02)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7416 6.3999C14.3169 6.3999 14.7833 6.86627 14.7833 7.44157V8.44157C14.7833 9.01687 14.3169 9.48324 13.7416 9.48324C13.1663 9.48324 12.7 9.01687 12.7 8.44157V7.44157C12.7 6.86627 13.1663 6.3999 13.7416 6.3999Z"
      fill="var(--col_text02)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91003 12.7716C6.91003 13.0974 7.17419 13.3616 7.50003 13.3616V12.7716V12.1816C7.17418 12.1816 6.91003 12.4457 6.91003 12.7716ZM12.6667 12.7716L12.6667 12.1816H7.50003V12.7716V13.3616H12.6659L12.6667 12.7716ZM12.6667 12.7716L12.6667 12.1816C12.9925 12.1816 13.2567 12.4457 13.2567 12.7716C13.2567 13.0974 12.9917 13.3616 12.6659 13.3616L12.6667 12.7716Z"
      fill="var(--col_text02)"
    />
  </svg>
);

export const SameIconActiveWeb = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M19.1673 10.4997C19.1673 15.5623 15.0633 19.6663 10.0007 19.6663C4.93804 19.6663 0.833984 15.5623 0.833984 10.4997C0.833984 5.43706 4.93804 1.33301 10.0007 1.33301C15.0633 1.33301 19.1673 5.43706 19.1673 10.4997Z"
      fill="url(#paint0_linear_772_8022)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91016 13.2363C6.91016 13.5815 7.17431 13.8613 7.50016 13.8613V13.2363V12.6113C7.17431 12.6113 6.91016 12.8912 6.91016 13.2363ZM12.6668 13.2363L12.6668 12.6113H7.50016V13.2363V13.8613H12.666L12.6668 13.2363ZM12.6668 13.2363L12.6668 12.6113C12.9927 12.6113 13.2568 12.8912 13.2568 13.2363C13.2568 13.5815 12.9918 13.8613 12.666 13.8613L12.6668 13.2363Z"
      fill="#222222"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25456 6.90039C6.82985 6.90039 7.29622 7.36676 7.29622 7.94206V8.94206C7.29622 9.51735 6.82985 9.98372 6.25456 9.98372C5.67926 9.98372 5.21289 9.51735 5.21289 8.94206V7.94206C5.21289 7.36676 5.67926 6.90039 6.25456 6.90039Z"
      fill="#222222"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7409 6.90039C14.3162 6.90039 14.7826 7.36676 14.7826 7.94206V8.94206C14.7826 9.51735 14.3162 9.98372 13.7409 9.98372C13.1656 9.98372 12.6992 9.51735 12.6992 8.94206V7.94206C12.6992 7.36676 13.1656 6.90039 13.7409 6.90039Z"
      fill="#222222"
    />
    <defs>
      <linearGradient
        id="paint0_linear_772_8022"
        x1="10.0007"
        y1="1.33301"
        x2="10.0007"
        y2="19.6663"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7DE1FF" />
        <stop offset="1" stopColor="#C7FFF2" />
      </linearGradient>
    </defs>
  </svg>
);

export const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 2.5L6 5.5M9 8.5L6 5.5M6 5.5L9 2.5M6 5.5L3 8.5"
      stroke="currentColor"
      strokeWidth="1.74"
      strokeLinecap="round"
    />
  </svg>
);

export const CloseFile = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 3L3 11"
      stroke="var(--col_text01)"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3L11 11"
      stroke="var(--col_text01)"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnSelectIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
      fill="#14151A"
      fillOpacity="0.25"
    />
  </svg>
);

export const VerticalLineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="12" viewBox="0 0 2 12" fill="none">
    <path d="M1 1L1 11" stroke="#EAEAEA" strokeLinecap="round" />
  </svg>
);

export const SelectIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" fill="#E1FADC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3387 10.6212C16.7292 10.2306 16.7292 9.59748 16.3387 9.20696C15.9482 8.81643 15.315 8.81643 14.9245 9.20696L11.3889 12.7426L9.62091 10.9748C9.23038 10.5843 8.59723 10.5843 8.20671 10.9748C7.81617 11.3654 7.81619 11.9986 8.20675 12.3891L10.6818 14.8639C10.951 15.1331 11.3356 15.2167 11.6765 15.1147C11.8301 15.0687 11.9748 14.9851 12.0961 14.8638L16.3387 10.6212Z"
      fill="#194132"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#194132"
    />
  </svg>
);

export const UserSelectIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" fill="#E1FADC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3387 10.6212C16.7292 10.2306 16.7292 9.59748 16.3387 9.20696C15.9482 8.81643 15.315 8.81643 14.9245 9.20696L11.3889 12.7426L9.62091 10.9748C9.23038 10.5843 8.59723 10.5843 8.20671 10.9748C7.81617 11.3654 7.81619 11.9986 8.20675 12.3891L10.6818 14.8639C10.951 15.1331 11.3356 15.2167 11.6765 15.1147C11.8301 15.0687 11.9748 14.9851 12.0961 14.8638L16.3387 10.6212Z"
      fill="#194132"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#194132"
    />
  </svg>
);

export const MiniLogoIcon = () => (
  <svg width="79" height="32" viewBox="0 0 79 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.299 21.431L38.298 21.4338L38.2967 21.4333L38.299 21.431ZM38.298 21.4338C37.849 22.7544 36.6448 24.3528 36.35 24.734L35.386 20.0912L33.5834 20.4657L33.8482 21.7427C33.5509 21.9497 33.2512 22.1311 32.9516 22.287V18.9793H35.5974V9.33791C35.5974 8.7378 35.1119 8.25165 34.5126 8.25165H32.9516V4.9231H30.8679V8.25165H29.2836C28.6843 8.25165 28.1988 8.7378 28.1988 9.33791V17.8931C28.1988 18.4932 28.6843 18.9793 29.2836 18.9793H30.8679V23.0406C29.1651 23.4174 27.8364 23.1941 27.8364 23.1941V25.3108C30.9283 25.6062 33.1397 24.6758 34.3128 23.9873L34.5497 25.1317L36.3245 24.7619C36.2989 24.7944 36.2827 24.8177 36.2827 24.8177L37.9366 26.1389C39.2003 24.7991 40.2874 22.1288 40.2874 22.1288L38.298 21.4338ZM33.739 10.1125V17.1185H32.9516V10.1125H33.739ZM30.0572 17.1208V10.1148H30.8702V17.1208H30.0572ZM24.7797 8.71221H12.5889L12.5842 8.71454C11.7526 9.54726 10.612 10.4056 9.07422 11.0778L8.22866 9.12625C8.22866 9.12625 11.1509 8.13535 12.6493 4.95333L14.6168 5.72093C14.6168 5.72093 14.496 6.07914 14.187 6.62576H24.7797V8.71221ZM4.05567 6.14934L5.94306 5.26526L7.99729 9.66236L6.1099 10.5464L4.05567 6.14934ZM4.05512 12.0428L5.94251 11.1588L7.99083 15.5432L6.10344 16.4273L4.05512 12.0428ZM3.70312 25.8458L5.64512 26.6855C7.25725 23.9291 8.09119 17.3674 8.09119 17.3674L6.00518 17.1743C5.30829 22.4661 3.70312 25.8458 3.70312 25.8458ZM23.2767 11.9314C23.2767 11.0475 22.5613 10.3311 21.6785 10.3311H11.8548C10.972 10.3311 10.2566 11.0475 10.2566 11.9314V15.8927H8.70019V17.9791H10.2566V21.9404C10.2566 22.8243 10.972 23.5407 11.8548 23.5407H20.1477C18.8143 24.8316 17.4647 25.2899 17.4647 25.2899L18.3103 27.2414C20.7099 26.1947 22.1408 24.6897 22.9469 23.5407H24.8308V21.4542H23.2744V17.9791H24.8308V15.8927H23.2744V11.9314H23.2767ZM21.4184 15.8927H18.5007L16.7725 12.192H21.4184V15.8927ZM12.1173 12.192H16.6726L14.8676 13.0363L16.201 15.8927H12.1149V12.192H12.1173ZM15.1069 17.9791L16.7307 21.4542H12.1149V17.9791H15.1046H15.1069ZM21.4184 21.4542H16.9118L18.6494 20.6401L17.4066 17.9791H21.4184V21.4542ZM45.524 17.5337L45.5235 17.5325L45.5211 17.5349L45.524 17.5337ZM45.7488 18.1001L45.524 17.5337L47.2332 16.8533L48.9289 21.1239L47.2169 21.8055L46.5363 20.0935C45.9602 20.3796 44.9404 20.7913 43.5699 20.9751V23.5453C43.5234 26.4389 40.0436 26.739 40.0436 26.739L39.8764 24.6502C41.4211 24.4595 41.456 23.6314 41.456 23.6314L41.4746 21.0681H36.9587C36.4454 21.0681 36.0272 20.6494 36.0272 20.1354V19.9144C36.0272 19.4515 36.3664 19.07 36.8101 18.9979L38.8543 17.8814L37.3049 17.6372C36.7473 17.5488 36.3664 17.0254 36.4547 16.4672L36.4616 16.43C36.5197 16.0694 36.7566 15.7857 37.0679 15.6508L39.2306 14.1295H37.7532C37.0726 14.1295 36.522 13.5783 36.522 12.8967V6.86532C36.522 6.18379 37.0726 5.63252 37.7532 5.63252H47.3098C47.9905 5.63252 48.541 6.18379 48.541 6.86532V12.8967C48.541 13.5783 47.9905 14.1295 47.3098 14.1295H46.0508L46.9753 15.8252L41.3166 18.9142C42.4665 19.0003 44.1018 18.9095 45.7488 18.1001ZM43.5745 12.2664H46.6826V10.9219H43.5745V12.2664ZM46.6826 8.83547V7.49102H43.5745V8.83547H46.6826ZM41.4908 8.83547V7.49102H38.3827V8.83547H41.4908ZM41.4908 10.9219H38.3827V12.2664H41.4908V10.9219ZM42.492 14.3807L40.2202 15.9811L41.8625 16.2392L45.7325 14.1249H42.3131L42.492 14.3807ZM46.8874 26.1365C45.6237 24.7991 44.5366 22.1265 44.5366 22.1265V22.1241L46.5274 21.4286C47.0407 22.9406 48.5414 24.8154 48.5414 24.8154L46.8874 26.1365ZM62.5254 7.40498L69.6197 25.8458H66.6022L64.8739 21.0937H56.9549L55.2267 25.8458H52.2347L59.329 7.40498H62.5254ZM64.0214 18.77L60.9783 10.4265H60.8761L57.8074 18.77H64.0214ZM74.2631 25.8458V7.40498H71.4778V25.8458H74.2631Z"
      fill="#E1FADC"
    />
  </svg>
);

export const ShareGraphIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#FAFAFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 15.8H18C16.785 15.8 15.8 16.785 15.8 18V28.4272L17.7042 26.523C18.6817 25.5455 20.2132 25.3938 21.3634 26.1606L22.754 27.0877C23.2766 27.4361 23.9843 27.2769 24.3074 26.7384L26.1979 23.5875C27.2575 21.8215 29.7689 21.6919 31.0046 23.3395L32.2 24.9334V18C32.2 16.785 31.215 15.8 30 15.8ZM32.2 27.9334L29.5646 24.4195C29.0959 23.7946 28.1433 23.8437 27.7414 24.5136L25.8509 27.6645C24.999 29.0843 23.1332 29.5038 21.7555 28.5854L20.365 27.6583C19.9287 27.3675 19.3478 27.425 18.977 27.7958L15.9564 30.8163C16.2806 31.6272 17.0734 32.2 18 32.2H30C31.215 32.2 32.2 31.215 32.2 30V27.9334ZM18 14C15.7909 14 14 15.7909 14 18V30C14 32.2091 15.7909 34 18 34H30C32.2091 34 34 32.2091 34 30V18C34 15.7909 32.2091 14 30 14H18ZM21.5 20C21.5 20.8284 20.8284 21.5 20 21.5C19.1716 21.5 18.5 20.8284 18.5 20C18.5 19.1716 19.1716 18.5 20 18.5C20.8284 18.5 21.5 19.1716 21.5 20Z"
      fill="#333333"
    />
  </svg>
);

export const ShareLinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#FAFAFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2858 17.1887C21.3537 13.6072 25.9334 12.38 29.515 14.4478C33.0965 16.5157 34.3237 21.0954 32.2559 24.6769L31.6993 25.6409C31.4478 26.0765 30.8908 26.2258 30.4552 25.9743C30.0196 25.7228 29.8704 25.1658 30.1219 24.7302L30.6784 23.7662C32.2433 21.0558 31.3146 17.5901 28.6042 16.0253C25.8939 14.4604 22.4281 15.3891 20.8633 18.0994L20.3067 19.0634C20.0552 19.499 19.4982 19.6483 19.0626 19.3968C18.627 19.1453 18.4778 18.5883 18.7293 18.1527L19.2858 17.1887ZM28.9373 28.6033C29.3729 28.8548 29.5222 29.4118 29.2707 29.8474L28.7141 30.8114C26.6463 34.3929 22.0666 35.6201 18.485 33.5522C14.9034 31.4844 13.6763 26.9047 15.7441 23.3232L16.3007 22.3592C16.5521 21.9236 17.1091 21.7744 17.5447 22.0258C17.9803 22.2773 18.1296 22.8343 17.8781 23.2699L17.3215 24.2339C15.7567 26.9443 16.6853 30.41 19.3957 31.9748C22.1061 33.5397 25.5719 32.611 27.1367 29.9006L27.6932 28.9367C27.9447 28.5011 28.5017 28.3518 28.9373 28.6033ZM26 20.536C25.5217 20.2599 24.9101 20.4237 24.634 20.902L21.634 26.0982C21.3578 26.5765 21.5217 27.1881 22 27.4642C22.4783 27.7404 23.0899 27.5765 23.366 27.0982L26.366 21.902C26.6422 21.4237 26.4783 20.8122 26 20.536Z"
      fill="#333333"
    />
  </svg>
);

export const ShareDeleteIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#FAFAFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1999 15.2999C19.1999 14.8028 19.6028 14.3999 20.0999 14.3999H27.8999C28.397 14.3999 28.7999 14.8028 28.7999 15.2999C28.7999 15.797 28.397 16.1999 27.8999 16.1999H20.0999C19.6028 16.1999 19.1999 15.797 19.1999 15.2999ZM14.3999 18.8999C14.3999 18.4028 14.8028 17.9999 15.2999 17.9999H16.7999H31.1999H32.6999C33.197 17.9999 33.5999 18.4028 33.5999 18.8999C33.5999 19.397 33.197 19.7999 32.6999 19.7999H31.1999V29.9999C31.1999 31.9881 29.5881 33.5999 27.5999 33.5999H20.3999C18.4117 33.5999 16.7999 31.9881 16.7999 29.9999V19.7999H15.2999C14.8028 19.7999 14.3999 19.397 14.3999 18.8999ZM18.5999 19.7999V29.9999C18.5999 30.994 19.4058 31.7999 20.3999 31.7999H27.5999C28.594 31.7999 29.3999 30.994 29.3999 29.9999V19.7999H18.5999ZM20.9999 22.4999C20.9999 22.0028 21.4028 21.5999 21.8999 21.5999C22.397 21.5999 22.7999 22.0028 22.7999 22.4999V27.8999C22.7999 28.397 22.397 28.7999 21.8999 28.7999C21.4028 28.7999 20.9999 28.397 20.9999 27.8999V22.4999ZM26.0999 21.5999C25.6028 21.5999 25.1999 22.0028 25.1999 22.4999V27.8999C25.1999 28.397 25.6028 28.7999 26.0999 28.7999C26.597 28.7999 26.9999 28.397 26.9999 27.8999V22.4999C26.9999 22.0028 26.597 21.5999 26.0999 21.5999Z"
      fill="#333333"
    />
  </svg>
);

export const ShareCloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25654 5.31695C3.96364 5.02406 3.96364 4.54918 4.25654 4.25629C4.54943 3.9634 5.0243 3.9634 5.3172 4.25629L9.99992 8.93902L14.6826 4.25629C14.9755 3.9634 15.4504 3.9634 15.7433 4.25629C16.0362 4.54918 16.0362 5.02406 15.7433 5.31695L11.0606 9.99968L15.7433 14.6824C16.0362 14.9753 16.0362 15.4502 15.7433 15.7431C15.4504 16.0359 14.9755 16.0359 14.6826 15.7431L9.99992 11.0603L5.31721 15.7431C5.02431 16.0359 4.54944 16.0359 4.25655 15.7431C3.96365 15.4502 3.96365 14.9753 4.25655 14.6824L8.93926 9.99968L4.25654 5.31695Z"
      fill="#333333"
    />
  </svg>
);

export const MiniDeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 3.20312C6.25 2.8148 6.5648 2.5 6.95312 2.5H13.0469C13.4352 2.5 13.75 2.8148 13.75 3.20312C13.75 3.59145 13.4352 3.90625 13.0469 3.90625H6.95312C6.5648 3.90625 6.25 3.59145 6.25 3.20312ZM2.5 6.01562C2.5 5.6273 2.8148 5.3125 3.20312 5.3125H4.375H15.625H16.7969C17.1852 5.3125 17.5 5.6273 17.5 6.01562C17.5 6.40395 17.1852 6.71875 16.7969 6.71875H15.625V14.6875C15.625 16.2408 14.3658 17.5 12.8125 17.5H7.1875C5.6342 17.5 4.375 16.2408 4.375 14.6875V6.71875H3.20312C2.8148 6.71875 2.5 6.40395 2.5 6.01562ZM5.78125 6.71875V14.6875C5.78125 15.4642 6.41085 16.0938 7.1875 16.0938H12.8125C13.5892 16.0938 14.2188 15.4642 14.2188 14.6875V6.71875H5.78125ZM7.65625 8.82812C7.65625 8.4398 7.97105 8.125 8.35938 8.125C8.7477 8.125 9.0625 8.4398 9.0625 8.82812V13.0469C9.0625 13.4352 8.7477 13.75 8.35938 13.75C7.97105 13.75 7.65625 13.4352 7.65625 13.0469V8.82812ZM11.6406 8.125C11.2523 8.125 10.9375 8.4398 10.9375 8.82812V13.0469C10.9375 13.4352 11.2523 13.75 11.6406 13.75C12.0289 13.75 12.3438 13.4352 12.3438 13.0469V8.82812C12.3438 8.4398 12.0289 8.125 11.6406 8.125Z"
      fill="#66676A"
    />
  </svg>
);

export const AddIcon = (props: { className?: any }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    className={props.className}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.41276 3.21422C4.54297 3.21422 3.0272 4.72998 3.0272 6.59977V11.4103C3.0272 12.8063 3.87224 14.0065 5.08157 14.5243L5.41971 14.6691L5.85625 16.6666C5.87058 16.7322 5.9416 16.768 6.00281 16.7405L10.3313 14.7958H13.5192C15.389 14.7958 16.9048 13.2801 16.9048 11.4103V6.59978C16.9048 4.72998 15.389 3.21422 13.5192 3.21422H6.41276ZM1.59863 6.59977C1.59863 3.941 3.75399 1.78564 6.41276 1.78564H13.5192C16.178 1.78564 18.3333 3.94101 18.3333 6.59978V11.4103C18.3333 14.0691 16.178 16.2244 13.5192 16.2244H10.6374L6.58825 18.0436C5.69956 18.4428 4.66863 17.9234 4.46062 16.9716L4.17721 15.6748C2.64525 14.8701 1.59863 13.2631 1.59863 11.4103V6.59977Z"
      fill="#333333"
    />
    <path d="M7.5 9.1665H12.5" stroke="#333333" strokeWidth="1.66667" strokeLinecap="round" />
    <path d="M10 11.6665L10 6.6665" stroke="#333333" strokeWidth="1.66667" strokeLinecap="round" />
  </svg>
);

export const FileLoadingOutLined = () => (
  <svg
    className="animate-spin"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="grad" x1="0%" y1="100%" x2="50%" y2="0%">
        <stop offset="0%" stopColor="rgba(122, 126, 139, 1)"></stop>
        <stop offset="100%" stopColor="rgba(122, 126, 139, 0.08)"></stop>
      </linearGradient>
    </defs>

    <circle cx="12" cy="12" r="8" fill="" stroke="url(#grad)" strokeWidth="2"></circle>
  </svg>
);

export const LoadingOutlined = () => (
  <svg
    className="animate-spin"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="grad" x1="0%" y1="100%" x2="50%" y2="0%">
        <stop offset="0%" stopColor="rgba(255,255,255,1)"></stop>
        <stop offset="100%" stopColor="rgba(255,255,255,0)"></stop>
      </linearGradient>
    </defs>

    <circle cx="12" cy="12" r="8" fill="" stroke="url(#grad)" strokeWidth="4"></circle>
  </svg>
);

export const FileErrorIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 6.6665C4 4.45736 5.79086 2.6665 8 2.6665H20V10.6665H28V25.3332C28 27.5423 26.2091 29.3332 24 29.3332H8C5.79086 29.3332 4 27.5423 4 25.3332V22.6665V14.6665V6.6665Z"
      fill="#999999"
    />
    <path d="M21.3334 2.6665L28 9.33317H21.3334V2.6665Z" fill="#999999" />
    <path
      d="M16.2211 12C16.8572 12 17.3637 12.5107 17.332 13.1199L17.1678 16.268C17.1367 16.8648 16.6231 17.3333 16 17.3333Lnan nanLnan nanL16 17.3333C15.377 17.3333 14.8634 16.8648 14.8323 16.268L14.6681 13.1199C14.6364 12.5107 15.1429 12 15.779 12L16.2211 12Z"
      fill="white"
    />
    <path
      d="M17.3333 19.9998C17.3333 20.7362 16.7363 21.3332 16 21.3332C15.2636 21.3332 14.6666 20.7362 14.6666 19.9998C14.6666 19.2635 15.2636 18.6665 16 18.6665C16.7363 18.6665 17.3333 19.2635 17.3333 19.9998Z"
      fill="white"
    />
  </svg>
);

export const ImageErrorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 3.5C3.84315 3.5 2.5 4.84315 2.5 6.5V17.5C2.5 19.1569 3.84315 20.5 5.5 20.5H14.3762C13.9128 19.9072 13.55 19.232 13.3135 18.5H5.5C4.94772 18.5 4.5 18.0523 4.5 17.5V6.5C4.5 5.94772 4.94772 5.5 5.5 5.5H18.5C19.0523 5.5 19.5 5.94771 19.5 6.5L19.5 10C20.1978 10 20.8699 10.11 21.5 10.3135V6.5C21.5 4.84315 20.1569 3.5 18.5 3.5H5.5Z"
      fill="#999999"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.013 11.0133C14.2016 12.167 13.0001 14.193 13 16.4996L6.44311 16.4996C6.04204 16.4996 5.8042 16.0511 6.02921 15.7191L7.77922 13.1368C8.13422 12.613 8.88038 12.5465 9.32248 12.9992L9.55886 13.2413C9.95542 13.6473 10.6101 13.6423 11.0004 13.2302L13.8188 10.2543C14.209 9.84226 14.8635 9.83713 15.2601 10.243L16.013 11.0133Z"
      fill="#999999"
    />
    <path
      d="M8.75 8.75C8.75 9.44036 8.19036 10 7.5 10C6.80964 10 6.25 9.44036 6.25 8.75C6.25 8.05964 6.80964 7.5 7.5 7.5C8.19036 7.5 8.75 8.05964 8.75 8.75Z"
      fill="#999999"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 16.5C15 14.0147 17.0147 12 19.5 12C21.9853 12 24 14.0147 24 16.5C24 18.9853 21.9853 21 19.5 21C17.0147 21 15 18.9853 15 16.5Z"
      fill="#999999"
    />
    <path
      d="M19.5994 14.5C19.8853 14.5 20.113 14.7394 20.0987 15.025L20.0249 16.5006C20.011 16.7804 19.7801 17 19.5 17L-nan -nanL19.5 17C19.2199 17 18.989 16.7804 18.975 16.5006L18.9012 15.025C18.8869 14.7394 19.1147 14.5 19.4006 14.5L19.5994 14.5Z"
      fill="white"
    />
    <path
      d="M20 18C20 18.2761 19.7761 18.5 19.5 18.5C19.2239 18.5 19 18.2761 19 18C19 17.7239 19.2239 17.5 19.5 17.5C19.7761 17.5 20 17.7239 20 18Z"
      fill="white"
    />
  </svg>
);

export const FileLoadingIcon = () => (
  <img
    width={10}
    height={10}
    className="h-[10px] w-[10px] animate-spin select-none"
    src="data:image/svg+xml;base64,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"
    alt="loading image"
  />
);

export const FileRetryIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" transform="matrix(-1 0 0 1 24 0)" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.208 16.5078C15.6975 15.8408 17.1749 13.2819 16.5078 10.7923C16.4125 10.4367 16.6236 10.0711 16.9792 9.97585C17.3349 9.88055 17.7004 10.0916 17.7957 10.4473C18.6534 13.648 16.7539 16.9381 13.5531 17.7957C11.5605 18.3296 9.53352 17.7944 8.08174 16.5446C7.8027 16.3044 7.77123 15.8835 8.01143 15.6045C8.25164 15.3254 8.67258 15.2939 8.95162 15.5341C10.0835 16.5085 11.6592 16.9228 13.208 16.5078ZM7.0211 14.0245C6.66546 14.1198 6.2999 13.9087 6.20461 13.5531C5.34696 10.3523 7.24645 7.06226 10.4472 6.20461C12.4398 5.6707 14.4668 6.20594 15.9186 7.45569C16.1976 7.6959 16.2291 8.11684 15.9889 8.39588C15.7487 8.67492 15.3277 8.7064 15.0487 8.46619C13.9168 7.49183 12.3411 7.07753 10.7923 7.49251C8.30283 8.15957 6.82545 10.7185 7.49251 13.208C7.5878 13.5636 7.37675 13.9292 7.0211 14.0245Z"
      fill="#194132"
    />
    <path
      d="M17.3193 13.3183L15.5619 13.3183C15.1677 13.3183 14.9285 12.8834 15.1396 12.5505L16.607 10.237C16.8431 10.295 17.0175 10.4946 17.0434 10.7364L17.3193 13.3183Z"
      fill="#194132"
    />
    <path
      d="M6.68066 10.682H8.43813C8.83233 10.682 9.0715 11.1169 8.86036 11.4498L7.39301 13.7633C7.15693 13.7053 6.98246 13.5057 6.95663 13.2639L6.68066 10.682Z"
      fill="#194132"
    />
  </svg>
);

export const TelPauseBtnIcon = () => (
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.16" x="8" y="8" width="72" height="72" rx="36" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36 32C33.7909 32 32 33.7909 32 36V52C32 54.2091 33.7909 56 36 56C38.2091 56 40 54.2091 40 52V36C40 33.7909 38.2091 32 36 32ZM52.5 32C50.567 32 49 33.567 49 35.5V52.5C49 54.433 50.567 56 52.5 56C54.433 56 56 54.433 56 52.5V35.5C56 33.567 54.433 32 52.5 32Z"
      fill="white"
    />
  </svg>
);

export const TelRestoreBtnIcon = () => (
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.16" x="7.5" y="8" width="72" height="72" rx="36" fill="white" />
    <path
      d="M36 35.8364C36 32.7774 39.2542 30.9529 41.6837 32.6497L53.3721 40.8133C55.5426 42.3292 55.5426 45.6708 53.3721 47.1867L41.6837 55.3503C39.2542 57.0471 36 55.2226 36 52.1636V35.8364Z"
      fill="white"
    />
  </svg>
);

export const TelVoiceSwitchIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92893 5.89964C6.8043 4.04303 9.34784 3 12 3C14.6522 3 17.1957 4.04303 19.0711 5.89964C20.9464 7.75625 22 10.2744 22 12.9V18.3H20.1818V12.9C20.1818 10.7517 19.3198 8.69148 17.7854 7.17244C16.251 5.65339 14.17 4.8 12 4.8C9.83005 4.8 7.74897 5.65339 6.21458 7.17243C4.68019 8.69148 3.81818 10.7517 3.81818 12.9V18.3H2V12.9C2 10.2744 3.05357 7.75625 4.92893 5.89964Z"
      fill="white"
    />
    <path
      d="M2 13.8H5.63636C6.13844 13.8 6.54545 14.2029 6.54545 14.7V20.1C6.54545 20.5971 6.13844 21 5.63636 21H4.72727C3.22104 21 2 19.7912 2 18.3V13.8Z"
      fill="white"
    />
    <path
      d="M22 13.8H18.3636C17.8616 13.8 17.4545 14.2029 17.4545 14.7V20.1C17.4545 20.5971 17.8616 21 18.3636 21H19.2727C20.779 21 22 19.7912 22 18.3V13.8Z"
      fill="white"
    />
    <path
      d="M11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V15Z"
      fill="#C3FAAF"
    />
    <path
      d="M14 17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18L14 17Z"
      fill="#C3FAAF"
    />
    <path
      d="M8 17C8 16.4477 8.44772 16 9 16C9.55228 16 10 16.4477 10 17V18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18L8 17Z"
      fill="#C3FAAF"
    />
  </svg>
);

export const TelVoiceSwitcherCloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="none" />
    <path
      d="M4.2216 4.22182C4.61213 3.83129 5.24529 3.83129 5.63582 4.22182L19.778 18.364C20.1685 18.7545 20.1685 19.3876 19.778 19.7782C19.3874 20.1687 18.7543 20.1687 18.3637 19.7782L4.2216 5.63603C3.83108 5.24551 3.83108 4.61234 4.2216 4.22182Z"
      fill="#333333"
    />
    <path
      d="M19.7782 4.22185C20.1688 4.61237 20.1688 5.24553 19.7782 5.63606L5.6361 19.7782C5.24558 20.1687 4.61242 20.1687 4.22189 19.7779C3.83137 19.3874 3.83137 18.7543 4.22189 18.3637L18.364 4.22185C18.7546 3.83132 19.3877 3.83132 19.7782 4.22185Z"
      fill="#333333"
    />
  </svg>
);

export const TelVoiceWaveIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.25944 3C9.25944 2.53976 9.63253 2.16666 10.0928 2.16666C10.553 2.16666 10.9261 2.53976 10.9261 3V18C10.9261 18.4602 10.553 18.8333 10.0928 18.8333C9.63253 18.8333 9.25944 18.4602 9.25944 18V3Z"
      fill="currentColor"
    />
    <path
      d="M5.92611 6.33333C5.92611 5.87309 6.2992 5.5 6.75944 5.5C7.21968 5.5 7.59277 5.87309 7.59277 6.33333V14.6667C7.59277 15.1269 7.21968 15.5 6.75944 15.5C6.2992 15.5 5.92611 15.1269 5.92611 14.6667V6.33333Z"
      fill="currentColor"
    />
    <path
      d="M12.5928 6.33333C12.5928 5.87309 12.9659 5.5 13.4261 5.5C13.8863 5.5 14.2594 5.87309 14.2594 6.33333V14.6667C14.2594 15.1269 13.8863 15.5 13.4261 15.5C12.9659 15.5 12.5928 15.1269 12.5928 14.6667V6.33333Z"
      fill="currentColor"
    />
    <path
      d="M15.9261 9.66666C15.9261 9.20643 16.2992 8.83333 16.7594 8.83333C17.2197 8.83333 17.5928 9.20643 17.5928 9.66666V11.3333C17.5928 11.7936 17.2197 12.1667 16.7594 12.1667C16.2992 12.1667 15.9261 11.7936 15.9261 11.3333V9.66666Z"
      fill="currentColor"
    />
    <path
      d="M2.59277 9.66666C2.59277 9.20643 2.96587 8.83333 3.42611 8.83333C3.88634 8.83333 4.25944 9.20643 4.25944 9.66666V11.3333C4.25944 11.7936 3.88634 12.1667 3.42611 12.1667C2.96587 12.1667 2.59277 11.7936 2.59277 11.3333V9.66666Z"
      fill="currentColor"
    />
  </svg>
);

export const TelVoiceChooseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#194132" />
    <rect
      x="3.75952"
      y="7.64771"
      width="2"
      height="5"
      rx="1"
      transform="rotate(-45 3.75952 7.64771)"
      fill="#C3FAAF"
    />
    <rect
      x="10.8298"
      y="4.81958"
      width="2"
      height="7"
      rx="1"
      transform="rotate(45 10.8298 4.81958)"
      fill="#C3FAAF"
    />
  </svg>
);

export const TelVoiceOperateIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6663 11.6667C17.5868 11.6667 18.333 10.9205 18.333 10C18.333 9.07952 17.5868 8.33333 16.6663 8.33333C15.7459 8.33333 14.9997 9.07952 14.9997 10C14.9997 10.9205 15.7459 11.6667 16.6663 11.6667ZM11.6663 10C11.6663 10.9205 10.9201 11.6667 9.99967 11.6667C9.0792 11.6667 8.33301 10.9205 8.33301 10C8.33301 9.07952 9.0792 8.33333 9.99967 8.33333C10.9201 8.33333 11.6663 9.07952 11.6663 10ZM4.99968 10C4.99968 10.9205 4.25348 11.6667 3.33301 11.6667C2.41254 11.6667 1.66634 10.9205 1.66634 10C1.66634 9.07952 2.41254 8.33333 3.33301 8.33333C4.25348 8.33333 4.99968 9.07952 4.99968 10Z"
      fill="#194132"
    />
  </svg>
);

export const TelVoiceEditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.94266 2.34308C9.98406 1.30168 11.6725 1.30168 12.7139 2.34308L13.6567 3.28589C14.6981 4.32729 14.6981 6.01573 13.6567 7.05712L8.11423 12.5996C7.61414 13.0997 6.93586 13.3806 6.22862 13.3806H3.95247C3.21609 13.3806 2.61914 12.7837 2.61914 12.0473L2.61914 9.77117C2.61914 9.06392 2.90009 8.38565 3.40019 7.88555L8.94266 2.34308ZM11.7711 3.28589C11.2504 2.76519 10.4062 2.76519 9.88547 3.28589L4.343 8.82836C4.09295 9.07841 3.95247 9.41755 3.95247 9.77117L3.95247 12.0473H6.22862C6.58224 12.0473 6.92138 11.9068 7.17143 11.6568L12.7139 6.11432C13.2346 5.59362 13.2346 4.7494 12.7139 4.2287L11.7711 3.28589Z"
      fill="#333333"
    />
    <path
      d="M8.47126 3.75729C8.73161 3.49694 9.15372 3.49694 9.41407 3.75729L12.2425 6.58572C12.5028 6.84607 12.5028 7.26818 12.2425 7.52853C11.9821 7.78888 11.56 7.78888 11.2997 7.52853L8.47126 4.7001C8.21091 4.43975 8.21091 4.01764 8.47126 3.75729Z"
      fill="#333333"
    />
  </svg>
);

export const TelVoiceDeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66699 4H13.3337V12C13.3337 13.4728 12.1398 14.6667 10.667 14.6667H5.33366C3.8609 14.6667 2.66699 13.4728 2.66699 12V4ZM4.00033 5.33333V12C4.00033 12.7364 4.59728 13.3333 5.33366 13.3333H10.667C11.4034 13.3333 12.0003 12.7364 12.0003 12V5.33333H4.00033Z"
      fill="#F55762"
    />
    <path
      d="M6 8C6 7.63181 6.29848 7.33334 6.66667 7.33334C7.03486 7.33334 7.33333 7.63181 7.33333 8V10.6667C7.33333 11.0349 7.03486 11.3333 6.66667 11.3333C6.29848 11.3333 6 11.0349 6 10.6667V8Z"
      fill="#F55762"
    />
    <path
      d="M8.66699 8C8.66699 7.63181 8.96547 7.33334 9.33366 7.33334C9.70185 7.33334 10.0003 7.63181 10.0003 8V10.6667C10.0003 11.0349 9.70185 11.3333 9.33366 11.3333C8.96547 11.3333 8.66699 11.0349 8.66699 10.6667V8Z"
      fill="#F55762"
    />
    <rect x="1.33301" y="4" width="13.3333" height="1.33333" rx="0.666667" fill="#F55762" />
    <path
      d="M4.66699 2C4.66699 1.63181 4.96547 1.33333 5.33366 1.33333L10.667 1.33333C11.0352 1.33333 11.3337 1.63181 11.3337 2C11.3337 2.36819 11.0352 2.66667 10.667 2.66667H5.33366C4.96547 2.66667 4.66699 2.36819 4.66699 2Z"
      fill="#F55762"
    />
  </svg>
);

export const FileCloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6673 8.00016C14.6673 11.6821 11.6825 14.6668 8.00065 14.6668C4.31875 14.6668 1.33398 11.6821 1.33398 8.00016C1.33398 4.31826 4.31875 1.3335 8.00065 1.3335C11.6825 1.3335 14.6673 4.31826 14.6673 8.00016ZM6.11518 6.1147C6.37553 5.85435 6.79764 5.85435 7.05799 6.1147L8.00096 7.05766L8.94386 6.11476C9.20421 5.85441 9.62632 5.85441 9.88667 6.11476C10.147 6.37511 10.147 6.79722 9.88667 7.05757L8.94377 8.00047L9.88642 8.94312C10.1468 9.20347 10.1468 9.62558 9.88642 9.88593C9.62607 10.1463 9.20396 10.1463 8.94361 9.88593L8.00096 8.94328L7.05824 9.88599C6.79789 10.1463 6.37578 10.1463 6.11543 9.88599C5.85508 9.62564 5.85508 9.20354 6.11543 8.94318L7.05815 8.00047L6.11518 7.05751C5.85484 6.79716 5.85483 6.37505 6.11518 6.1147Z"
      fill="currentColor"
    />
  </svg>
);

export const FileCloseIconHover = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6673 8.00016C14.6673 11.6821 11.6825 14.6668 8.00065 14.6668C4.31875 14.6668 1.33398 11.6821 1.33398 8.00016C1.33398 4.31826 4.31875 1.3335 8.00065 1.3335C11.6825 1.3335 14.6673 4.31826 14.6673 8.00016ZM6.11518 6.1147C6.37553 5.85435 6.79764 5.85435 7.05799 6.1147L8.00096 7.05766L8.94386 6.11476C9.20421 5.85441 9.62632 5.85441 9.88667 6.11476C10.147 6.37511 10.147 6.79722 9.88667 7.05757L8.94377 8.00047L9.88642 8.94312C10.1468 9.20347 10.1468 9.62558 9.88642 9.88593C9.62607 10.1463 9.20396 10.1463 8.94361 9.88593L8.00096 8.94328L7.05824 9.88599C6.79789 10.1463 6.37578 10.1463 6.11543 9.88599C5.85508 9.62564 5.85508 9.20354 6.11543 8.94318L7.05815 8.00047L6.11518 7.05751C5.85484 6.79716 5.85483 6.37505 6.11518 6.1147Z"
      fill="var(--col_brand01)"
    />
  </svg>
);

export const InputFileCloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 8C13.3333 10.9455 10.9455 13.3333 7.99996 13.3333C5.05444 13.3333 2.66663 10.9455 2.66663 8C2.66663 5.05449 5.05444 2.66667 7.99996 2.66667C10.9455 2.66667 13.3333 5.05449 13.3333 8Z"
      fill="black"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00004 13.3333C10.9456 13.3333 13.3334 10.9455 13.3334 8C13.3334 5.05448 10.9456 2.66666 8.00004 2.66666C5.05452 2.66666 2.66671 5.05448 2.66671 8C2.66671 10.9455 5.05452 13.3333 8.00004 13.3333ZM8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8.00004 1.33333C4.31814 1.33333 1.33337 4.3181 1.33337 8C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z"
      fill="white"
    />
    <path
      d="M6.11441 6.11438C6.37476 5.85403 6.79687 5.85403 7.05722 6.11438L9.88565 8.94281C10.146 9.20316 10.146 9.62527 9.88565 9.88562C9.6253 10.146 9.20319 10.146 8.94284 9.88562L6.11441 7.05719C5.85406 6.79684 5.85406 6.37473 6.11441 6.11438Z"
      fill="white"
    />
    <path
      d="M9.88565 6.11438C10.146 6.37473 10.146 6.79684 9.88565 7.05719L7.05723 9.88562C6.79688 10.146 6.37477 10.146 6.11442 9.88562C5.85407 9.62527 5.85407 9.20316 6.11442 8.94281L8.94284 6.11438C9.20319 5.85403 9.6253 5.85403 9.88565 6.11438Z"
      fill="white"
    />
  </svg>
);

export const TelVoicePlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00033 2.66666C7.63214 2.66666 7.33366 2.96513 7.33366 3.33332V7.33332H3.33366C2.96547 7.33332 2.66699 7.6318 2.66699 7.99999C2.66699 8.36818 2.96547 8.66666 3.33366 8.66666H7.33366V12.6667C7.33366 13.0348 7.63214 13.3333 8.00033 13.3333C8.36852 13.3333 8.66699 13.0348 8.66699 12.6667V8.66666H12.667C13.0352 8.66666 13.3337 8.36818 13.3337 7.99999C13.3337 7.6318 13.0352 7.33332 12.667 7.33332H8.66699V3.33332C8.66699 2.96513 8.36852 2.66666 8.00033 2.66666Z"
      fill="#C3FAAF"
    />
  </svg>
);

export const TelReprintNoticeIcon1 = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_685_18523)">
      <path
        d="M8.82492 10.0749H9.2105L9.52909 9.85768L16.43 5.15251C18.2555 3.90787 20.7292 5.21523 20.7292 7.42463V24.5753C20.7292 26.7847 18.2555 28.092 16.43 26.8474L9.52909 22.1422L9.2105 21.925H8.82492H6.8457C5.32692 21.925 4.0957 20.6938 4.0957 19.175V12.8249C4.0957 11.3061 5.32692 10.0749 6.8457 10.0749H8.82492Z"
        fill="#E1FADC"
        stroke="#194132"
        strokeWidth="2.5"
      />
      <path
        d="M23.1748 13.6082L26.7623 12.4124L25.5662 10.0207L29.1537 8.82483"
        stroke="#194132"
        strokeWidth="2.5"
      />
      <path
        d="M23.1748 20.7834L25.5665 21.9792L26.7623 19.5875L29.154 20.7834"
        stroke="#194132"
        strokeWidth="2.5"
      />
      <path
        d="M1.1164 27.4248L0.232519 28.3086L1.1164 29.1925L2.80758 30.8837L3.69146 31.7676L4.57535 30.8837L30.8839 4.57517L31.7678 3.69128L30.8839 2.8074L29.1927 1.11622L28.3088 0.23234L27.4249 1.11622L1.1164 27.4248Z"
        fill="#194132"
        stroke="white"
        strokeWidth="2.5"
      />
      <path d="M29.1543 2.8457L2.84576 29.1542" stroke="#194132" />
    </g>
    <defs>
      <clipPath id="clip0_685_18523">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TelReprintNoticeIcon2 = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 14H26C27.933 14 29.5 15.567 29.5 17.5C29.5 19.433 27.933 21 26 21H21"
      stroke="#194132"
      strokeWidth="2.5"
    />
    <path
      d="M5 15C5 13.3431 6.34315 12 8 12H22C23.6569 12 25 13.3431 25 15V20C25 24.4183 21.4183 28 17 28H15H13C8.58172 28 5 24.4183 5 20L5 15Z"
      fill="#E1FADC"
      stroke="#194132"
      strokeWidth="2.5"
    />
    <path
      d="M9 4.5L8.76072 5.21783C8.59622 5.71134 8.66878 6.25317 8.95734 6.68601V6.68601C9.29291 7.18936 9.33304 7.83393 9.06249 8.37501L9 8.5"
      stroke="#194132"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M15 4.5L14.9472 4.60557C14.6657 5.16863 14.6657 5.83137 14.9472 6.39443L15 6.5L15.0528 6.60557C15.3343 7.16863 15.3343 7.83137 15.0528 8.39443L15 8.5"
      stroke="#194132"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M21 4.5L20.9472 4.60557C20.6657 5.16863 20.6657 5.83137 20.9472 6.39443L21 6.5L21.0528 6.60557C21.3343 7.16863 21.3343 7.83137 21.0528 8.39443L21 8.5"
      stroke="#194132"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const TelReprintNoticeIcon3 = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="14" fill="#E1FADC" />
    <path
      d="M3.13281 16C3.13281 8.89337 8.89385 3.13232 16.0005 3.13232C23.1071 3.13232 28.8681 8.89337 28.8681 16C28.8681 23.1066 23.1071 28.8676 16.0005 28.8676C8.89385 28.8676 3.13281 23.1066 3.13281 16Z"
      stroke="#194132"
      strokeWidth="2.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9996 11.0769C14.3203 11.0769 12.9589 12.4383 12.9589 14.1176C12.9589 15.797 14.3203 17.1584 15.9996 17.1584C17.6789 17.1584 19.0403 15.797 19.0403 14.1176C19.0403 12.4383 17.6789 11.0769 15.9996 11.0769ZM10.3525 14.1176C10.3525 10.9989 12.8808 8.47058 15.9996 8.47058C19.1184 8.47058 21.6467 10.9989 21.6467 14.1176C21.6467 17.2364 19.1184 19.7647 15.9996 19.7647C12.8808 19.7647 10.3525 17.2364 10.3525 14.1176Z"
      fill="#194132"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.988 20.4706C12.2826 20.4706 9.17263 22.9741 8.316 26.3529C8.31601 27.2941 5.40267 26.3888 6.16541 24.4706C7.6988 20.6142 11.5185 17.8823 15.988 17.8823C20.4574 17.8823 24.2771 20.6142 25.8105 24.4706C26.4476 26.0729 23.6599 27.7647 23.6599 26.3529C22.8033 22.9741 19.6933 20.4706 15.988 20.4706Z"
      fill="#194132"
    />
  </svg>
);

export const TelRecordQuoteIcon = () => (
  <svg width="33" height="28" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_813_17090)">
      <path
        d="M26.8556 21H15.1801L21.7553 5.83331H32.2018L26.8556 21ZM12.5378 21H0.862305L7.43744 5.83331H17.8839L12.5378 21Z"
        fill="#194132"
      />
    </g>
    <defs>
      <clipPath id="clip0_813_17090">
        <rect width="31.3394" height="28" fill="white" transform="translate(0.862305)" />
      </clipPath>
    </defs>
  </svg>
);

export const TelRecordVoiceReadyIcon = () => (
  <svg width="81" height="3" viewBox="0 0 81 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="6" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="12" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="18" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="24" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="30" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="36" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="42" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="48" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="54" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="60" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="66" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="72" width="3" height="3" rx="1.5" fill="#999999" />
    <rect x="78" width="3" height="3" rx="1.5" fill="#999999" />
  </svg>
);

export const FollowUpIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.21967 2.46967C4.51256 2.17678 4.98744 2.17678 5.28033 2.46967L8.28033 5.46967C8.57322 5.76256 8.57322 6.23743 8.28033 6.53033L5.28036 9.53033C4.98746 9.82322 4.51259 9.82322 4.2197 9.53033C3.9268 9.23744 3.9268 8.76257 4.21969 8.46967L6.68934 6L4.21967 3.53033C3.92678 3.23744 3.92678 2.76256 4.21967 2.46967Z"
      fill="#999999"
    />
  </svg>
);

export const ShareLinkCopyModalCloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.2216 4.22176C4.61213 3.83123 5.24529 3.83123 5.63582 4.22176L19.778 18.3639C20.1685 18.7544 20.1685 19.3876 19.778 19.7781C19.3874 20.1686 18.7543 20.1686 18.3637 19.7781L4.2216 5.63597C3.83108 5.24544 3.83108 4.61228 4.2216 4.22176Z"
      fill="currentColor"
    />
    <path
      d="M19.7782 4.2216C20.1688 4.61213 20.1688 5.24529 19.7782 5.63581L5.6361 19.778C5.24558 20.1685 4.61242 20.1685 4.22189 19.7779C3.83137 19.3874 3.83137 18.7543 4.22189 18.3637L18.364 4.2216C18.7546 3.83108 19.3877 3.83108 19.7782 4.2216Z"
      fill="currentColor"
    />
  </svg>
);

export const ScreenshotLogoLightMode = () => (
  <svg width="90" height="29" viewBox="0 0 90 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.4994 14.0697C22.4994 7.85326 17.4374 2.79693 11.2209 2.81254C5.05301 2.82814 0.01503 7.86886 3.59998e-05 14.0409C-0.0155577 20.2609 5.03681 25.3268 11.2497 25.3268H18.6417C20.7685 25.3268 22.4928 23.6014 22.4928 21.4732V14.4448C22.497 14.3206 22.5 14.1957 22.5 14.0697H22.4994ZM5.46444 20.3215C3.67356 18.7917 2.57 16.3443 2.62098 13.8488C2.62458 13.6742 2.63358 13.4989 2.64857 13.3249L2.64977 13.3135C2.90887 10.3361 4.8305 7.55918 7.52461 6.26944C10.2187 4.9797 13.5858 5.22577 16.0646 6.89241C18.5434 8.55904 20.0422 11.5862 19.8671 14.5696C19.8287 15.2226 19.7159 15.8702 19.5588 16.5051C19.4964 16.7578 19.4208 17.0195 19.2421 17.2085C19.0634 17.3976 18.7503 17.4852 18.5386 17.3339C18.3365 17.1899 18.3065 16.9066 18.2891 16.6594C18.1493 14.6566 17.615 12.5921 16.2625 11.1097C15.2411 9.99042 13.7897 9.27804 12.2813 9.1382C10.7729 8.99836 9.22133 9.42927 7.99003 10.3121C6.96024 11.0509 6.15057 12.1078 5.75952 13.3141C5.36848 14.5204 5.40866 15.8714 5.92266 17.0309C6.29991 17.8819 6.92665 18.6207 7.70454 19.132C9.07979 20.0359 10.9618 20.1643 12.3911 19.3481C13.8203 18.5319 14.6743 16.7614 14.3103 15.1554C13.9462 13.5494 12.3197 12.2968 10.6829 12.4661C10.4328 12.4919 10.0754 12.4649 10.0664 12.2134C10.0592 12.019 10.2925 11.9163 10.4838 11.8821C12.1446 11.5838 13.9234 12.4277 14.8345 13.8488C15.7455 15.27 15.7917 17.1737 15.048 18.6891C14.3043 20.2045 12.8271 21.3118 11.1879 21.7115C8.97843 22.2504 6.97763 21.6131 5.46624 20.3215H5.46444Z"
      fill="url(#paint0_linear_288_15043)"
    />
    <path
      d="M82.537 21.6616L81.4467 18.5617H75.099L74.0087 21.6616H71.4128L76.8449 6.46875H79.7246L85.1566 21.6616H82.5386H82.537ZM80.7485 16.5314L78.2831 9.48093L75.7964 16.5314H80.7485Z"
      fill="#222222"
    />
    <path d="M87.5115 21.6618V6.49023H89.9982V21.6618H87.5115Z" fill="#222222" />
    <path
      d="M35.1815 14.3814C34.054 13.3496 33.1076 12.5426 32.3438 11.9602L33.544 10.3762C33.7259 10.5099 33.8832 10.6373 34.0168 10.7584C34.8898 11.4499 35.6844 12.0931 36.4 12.6881L35.1807 14.3814H35.1815ZM32.4892 21.9177C32.732 21.1051 33.0712 19.9673 33.5076 18.5044C33.9441 17.0422 34.2169 16.1046 34.326 15.6916L36.1454 16.2557C35.9026 17.0691 35.6085 18.1096 35.263 19.3779C34.9174 20.6462 34.6352 21.6866 34.4169 22.5L32.4884 21.9177H32.4892ZM35.5998 9.7939C34.5933 8.90853 33.6595 8.14341 32.7984 7.50015L33.9441 5.98893C34.3442 6.28009 35.0598 6.84426 36.0908 7.68216L36.7819 8.24628L35.599 9.7939H35.5998ZM48.6794 15.9472H47.0782L47.0055 18.1863H48.4248V19.9341H46.9327V20.1343C46.9082 20.753 46.8086 21.2325 46.6323 21.5727C46.456 21.9121 46.18 22.1487 45.8044 22.2824C45.4281 22.4161 44.907 22.4826 44.2397 22.4826H41.511L41.1291 20.8622H43.6395C44.1005 20.8622 44.4397 20.7894 44.6579 20.6438C44.8762 20.4982 45.0035 20.2616 45.0398 19.9341H36.9266L37.363 15.9472H36.1074V14.1812H37.5631L37.8177 11.7236L37.5631 12.0148L36.1256 10.5764C37.5085 9.11976 38.606 7.47011 39.418 5.625L41.4375 5.97073C41.3157 6.23816 41.122 6.63851 40.8555 7.17258H48.2595V8.9204H39.8553C39.4426 9.56366 39.1824 9.96399 39.0733 10.1214H47.2957L47.1502 14.1812H48.6786V15.9472H48.6794ZM39.2386 15.9472L38.9658 18.1863H42.2582C41.3726 17.4948 40.8152 17.0699 40.5843 16.9124L41.3845 15.948H39.2378L39.2386 15.9472ZM39.7478 11.8693L39.4568 14.1812H42.6037C41.9728 13.6598 41.379 13.1985 40.8207 12.7973L41.5663 11.8693H39.747H39.7478ZM43.2039 18.1863H45.1142L45.2233 15.9472H42.0218L43.8957 17.3674L43.2047 18.1863H43.2039ZM45.3142 14.1812L45.4415 11.8693H42.2764C43.1738 12.5244 43.7621 12.9738 44.0412 13.2159L43.2592 14.1804H45.315L45.3142 14.1812Z"
      fill="#222222"
    />
    <path
      d="M63.67 18.2615V20.5553C63.67 21.053 63.6123 21.4319 63.4969 21.693C63.3814 21.9541 63.1846 22.1416 62.9055 22.2572C62.6263 22.3727 62.2262 22.4304 61.7044 22.4304H60.4859L60.1586 20.6827H60.977C61.3525 20.6827 61.5984 20.6344 61.7139 20.5371C61.8293 20.4398 61.887 20.2214 61.887 19.8819V18.3525L60.2132 18.4253L61.1952 19.7356C60.1641 20.6336 59.1149 21.4224 58.0482 22.1021L57.7209 21.5562L56.8116 21.7381C56.7507 21.2768 56.7088 20.9801 56.6843 20.8464C54.1739 21.2104 52.5482 21.4715 51.8089 21.6289L51.5725 19.7356L53.1737 19.5354L53.8647 19.4444V16.2226H52.0453V8.41331H53.9556V5.99219H55.6477V8.41331H57.5762V16.2226H55.5022V19.1896L56.4297 19.0441C56.4052 18.923 56.3815 18.7529 56.357 18.5345L56.1205 17.1689L57.2844 16.9687L57.83 20.2451C58.5938 19.7601 59.3766 19.1532 60.1768 18.4245L58.4665 18.4973L58.2119 17.0043C58.9149 16.7012 59.8004 16.2582 60.8678 15.6751L58.7575 15.7842L58.5575 14.4186C59.3695 14.0547 60.1823 13.5269 60.9951 12.8346H58.3392V6.44474H67.2353V12.8346H65.1977L66.4343 13.9083C65.355 14.7818 63.6993 15.7898 61.468 16.9299L64.9241 16.6934L64.3603 16.0382L65.5424 15.0737C66.5371 16.1656 67.3673 17.1127 68.0347 17.9134L66.8344 18.9871L66.1615 18.15L63.6693 18.2592L63.67 18.2615ZM54.1375 10.3431H53.2646V14.2936H54.1375V10.3431ZM55.4113 14.2928H56.266V10.3423H55.4113V14.2928ZM61.9788 9.03203V7.97656H60.0685V9.03203H61.9788ZM61.9788 10.2885H60.0685V11.4168H61.9788V10.2885ZM63.27 14.22C64.0456 13.7105 64.6529 13.2492 65.0893 12.8362H63.2881C62.8272 13.2365 62.4484 13.5491 62.1511 13.7738C61.8538 13.9985 61.5352 14.2082 61.196 14.402L63.27 14.22ZM63.5791 9.03203H65.4894V7.97656H63.5791V9.03203ZM63.5791 10.2885V11.4168H65.4894V10.2885H63.5791ZM65.0166 18.4435L68.2727 20.7554L67.2906 22.1575C66.8296 21.7935 66.2841 21.3805 65.6531 20.9192C65.0221 20.4579 64.5011 20.1003 64.0883 19.8455L65.0166 18.4435Z"
      fill="#222222"
    />
    <defs>
      <linearGradient
        id="paint0_linear_288_15043"
        x1="0.505033"
        y1="3.64195"
        x2="25.785"
        y2="28.1446"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

export const ScreenshotLogoDarkMode = () => (
  <svg width="90" height="29" viewBox="0 0 90 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.4994 14.0697C22.4994 7.85326 17.4374 2.79693 11.2209 2.81254C5.05301 2.82814 0.01503 7.86886 3.59998e-05 14.0409C-0.0155577 20.2609 5.03681 25.3268 11.2497 25.3268H18.6417C20.7685 25.3268 22.4928 23.6014 22.4928 21.4732V14.4448C22.497 14.3206 22.5 14.1957 22.5 14.0697H22.4994ZM5.46444 20.3215C3.67356 18.7917 2.57 16.3443 2.62098 13.8488C2.62458 13.6742 2.63358 13.4989 2.64857 13.3249L2.64977 13.3135C2.90887 10.3361 4.8305 7.55918 7.52461 6.26944C10.2187 4.9797 13.5858 5.22577 16.0646 6.89241C18.5434 8.55904 20.0422 11.5862 19.8671 14.5696C19.8287 15.2226 19.7159 15.8702 19.5588 16.5051C19.4964 16.7578 19.4208 17.0195 19.2421 17.2085C19.0634 17.3976 18.7503 17.4852 18.5386 17.3339C18.3365 17.1899 18.3065 16.9066 18.2891 16.6594C18.1493 14.6566 17.615 12.5921 16.2625 11.1097C15.2411 9.99042 13.7897 9.27804 12.2813 9.1382C10.7729 8.99836 9.22133 9.42927 7.99003 10.3121C6.96024 11.0509 6.15057 12.1078 5.75952 13.3141C5.36848 14.5204 5.40866 15.8714 5.92266 17.0309C6.29991 17.8819 6.92665 18.6207 7.70454 19.132C9.07979 20.0359 10.9618 20.1643 12.3911 19.3481C13.8203 18.5319 14.6743 16.7614 14.3103 15.1554C13.9462 13.5494 12.3197 12.2968 10.6829 12.4661C10.4328 12.4919 10.0754 12.4649 10.0664 12.2134C10.0592 12.019 10.2925 11.9163 10.4838 11.8821C12.1446 11.5838 13.9234 12.4277 14.8345 13.8488C15.7455 15.27 15.7917 17.1737 15.048 18.6891C14.3043 20.2045 12.8271 21.3118 11.1879 21.7115C8.97843 22.2504 6.97763 21.6131 5.46624 20.3215H5.46444Z"
      fill="url(#paint0_linear_299_23442)"
    />
    <path
      d="M82.537 21.6616L81.4467 18.5617H75.099L74.0087 21.6616H71.4128L76.8449 6.46875H79.7246L85.1566 21.6616H82.5386H82.537ZM80.7485 16.5314L78.2831 9.48093L75.7964 16.5314H80.7485Z"
      fill="white"
    />
    <path d="M87.5115 21.6618V6.49023H89.9982V21.6618H87.5115Z" fill="white" />
    <path
      d="M35.1815 14.3814C34.054 13.3496 33.1076 12.5426 32.3438 11.9602L33.544 10.3762C33.7259 10.5099 33.8832 10.6373 34.0168 10.7584C34.8898 11.4499 35.6844 12.0931 36.4 12.6881L35.1807 14.3814H35.1815ZM32.4892 21.9177C32.732 21.1051 33.0712 19.9673 33.5076 18.5044C33.9441 17.0422 34.2169 16.1046 34.326 15.6916L36.1454 16.2557C35.9026 17.0691 35.6085 18.1096 35.263 19.3779C34.9174 20.6462 34.6352 21.6866 34.4169 22.5L32.4884 21.9177H32.4892ZM35.5998 9.7939C34.5933 8.90853 33.6595 8.14341 32.7984 7.50015L33.9441 5.98893C34.3442 6.28009 35.0598 6.84426 36.0908 7.68216L36.7819 8.24628L35.599 9.7939H35.5998ZM48.6794 15.9472H47.0782L47.0055 18.1863H48.4248V19.9341H46.9327V20.1343C46.9082 20.753 46.8086 21.2325 46.6323 21.5727C46.456 21.9121 46.18 22.1487 45.8044 22.2824C45.4281 22.4161 44.907 22.4826 44.2397 22.4826H41.511L41.1291 20.8622H43.6395C44.1005 20.8622 44.4397 20.7894 44.6579 20.6438C44.8762 20.4982 45.0035 20.2616 45.0398 19.9341H36.9266L37.363 15.9472H36.1074V14.1812H37.5631L37.8177 11.7236L37.5631 12.0148L36.1256 10.5764C37.5085 9.11976 38.606 7.47011 39.418 5.625L41.4375 5.97073C41.3157 6.23816 41.122 6.63851 40.8555 7.17258H48.2595V8.9204H39.8553C39.4426 9.56366 39.1824 9.96399 39.0733 10.1214H47.2957L47.1502 14.1812H48.6786V15.9472H48.6794ZM39.2386 15.9472L38.9658 18.1863H42.2582C41.3726 17.4948 40.8152 17.0699 40.5843 16.9124L41.3845 15.948H39.2378L39.2386 15.9472ZM39.7478 11.8693L39.4568 14.1812H42.6037C41.9728 13.6598 41.379 13.1985 40.8207 12.7973L41.5663 11.8693H39.747H39.7478ZM43.2039 18.1863H45.1142L45.2233 15.9472H42.0218L43.8957 17.3674L43.2047 18.1863H43.2039ZM45.3142 14.1812L45.4415 11.8693H42.2764C43.1738 12.5244 43.7621 12.9738 44.0412 13.2159L43.2592 14.1804H45.315L45.3142 14.1812Z"
      fill="white"
    />
    <path
      d="M63.67 18.2615V20.5553C63.67 21.053 63.6123 21.4319 63.4969 21.693C63.3814 21.9541 63.1846 22.1416 62.9055 22.2572C62.6263 22.3727 62.2262 22.4304 61.7044 22.4304H60.4859L60.1586 20.6827H60.977C61.3525 20.6827 61.5984 20.6344 61.7139 20.5371C61.8293 20.4398 61.887 20.2214 61.887 19.8819V18.3525L60.2132 18.4253L61.1952 19.7356C60.1641 20.6336 59.1149 21.4224 58.0482 22.1021L57.7209 21.5562L56.8116 21.7381C56.7507 21.2768 56.7088 20.9801 56.6843 20.8464C54.1739 21.2104 52.5482 21.4715 51.8089 21.6289L51.5725 19.7356L53.1737 19.5354L53.8647 19.4444V16.2226H52.0453V8.41331H53.9556V5.99219H55.6477V8.41331H57.5762V16.2226H55.5022V19.1896L56.4297 19.0441C56.4052 18.923 56.3815 18.7529 56.357 18.5345L56.1205 17.1689L57.2844 16.9687L57.83 20.2451C58.5938 19.7601 59.3766 19.1532 60.1768 18.4245L58.4665 18.4973L58.2119 17.0043C58.9149 16.7012 59.8004 16.2582 60.8678 15.6751L58.7575 15.7842L58.5575 14.4186C59.3695 14.0547 60.1823 13.5269 60.9951 12.8346H58.3392V6.44474H67.2353V12.8346H65.1977L66.4343 13.9083C65.355 14.7818 63.6993 15.7898 61.468 16.9299L64.9241 16.6934L64.3603 16.0382L65.5424 15.0737C66.5371 16.1656 67.3673 17.1127 68.0347 17.9134L66.8344 18.9871L66.1615 18.15L63.6693 18.2592L63.67 18.2615ZM54.1375 10.3431H53.2646V14.2936H54.1375V10.3431ZM55.4113 14.2928H56.266V10.3423H55.4113V14.2928ZM61.9788 9.03203V7.97656H60.0685V9.03203H61.9788ZM61.9788 10.2885H60.0685V11.4168H61.9788V10.2885ZM63.27 14.22C64.0456 13.7105 64.6529 13.2492 65.0893 12.8362H63.2881C62.8272 13.2365 62.4484 13.5491 62.1511 13.7738C61.8538 13.9985 61.5352 14.2082 61.196 14.402L63.27 14.22ZM63.5791 9.03203H65.4894V7.97656H63.5791V9.03203ZM63.5791 10.2885V11.4168H65.4894V10.2885H63.5791ZM65.0166 18.4435L68.2727 20.7554L67.2906 22.1575C66.8296 21.7935 66.2841 21.3805 65.6531 20.9192C65.0221 20.4579 64.5011 20.1003 64.0883 19.8455L65.0166 18.4435Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_299_23442"
        x1="0.505033"
        y1="3.64195"
        x2="25.785"
        y2="28.1446"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

export const ScreenshotLogoHilo = () => (
  <svg width="134" height="28" viewBox="0 0 134 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.4994 14.0697C22.4994 7.85326 17.4374 2.79693 11.2209 2.81254C5.05301 2.82814 0.01503 7.86886 3.59998e-05 14.0409C-0.0155577 20.2609 5.03681 25.3268 11.2497 25.3268H18.6417C20.7685 25.3268 22.4928 23.6014 22.4928 21.4732V14.4448C22.497 14.3206 22.5 14.1957 22.5 14.0697H22.4994ZM5.46444 20.3215C3.67356 18.7917 2.57 16.3443 2.62098 13.8488C2.62458 13.6742 2.63358 13.4989 2.64857 13.3249L2.64977 13.3135C2.90887 10.3361 4.8305 7.55918 7.52461 6.26944C10.2187 4.9797 13.5858 5.22577 16.0646 6.89241C18.5434 8.55904 20.0422 11.5862 19.8671 14.5696C19.8287 15.2226 19.7159 15.8702 19.5588 16.5051C19.4964 16.7578 19.4208 17.0195 19.2421 17.2085C19.0634 17.3976 18.7503 17.4852 18.5386 17.3339C18.3365 17.1899 18.3065 16.9066 18.2891 16.6594C18.1493 14.6566 17.615 12.5921 16.2625 11.1097C15.2411 9.99042 13.7897 9.27804 12.2813 9.1382C10.7729 8.99836 9.22133 9.42927 7.99003 10.3121C6.96024 11.0509 6.15057 12.1078 5.75952 13.3141C5.36848 14.5204 5.40866 15.8714 5.92266 17.0309C6.29991 17.8819 6.92665 18.6207 7.70454 19.132C9.07979 20.0359 10.9618 20.1643 12.3911 19.3481C13.8203 18.5319 14.6743 16.7614 14.3103 15.1554C13.9462 13.5494 12.3197 12.2968 10.6829 12.4661C10.4328 12.4919 10.0754 12.4649 10.0664 12.2134C10.0592 12.019 10.2925 11.9163 10.4838 11.8821C12.1446 11.5838 13.9234 12.4277 14.8345 13.8488C15.7455 15.27 15.7917 17.1737 15.048 18.6891C14.3043 20.2045 12.8271 21.3118 11.1879 21.7115C8.97843 22.2504 6.97763 21.6131 5.46624 20.3215H5.46444Z"
      fill="url(#paint0_linear_288_14883)"
    />
    <path
      d="M46.74 6.556V22H42.978V15.642H37.126V22H33.364V6.556H37.126V12.606H42.978V6.556H46.74ZM49.1478 15.84C49.1478 14.5787 49.3825 13.4713 49.8518 12.518C50.3358 11.5647 50.9885 10.8313 51.8098 10.318C52.6311 9.80467 53.5478 9.548 54.5598 9.548C55.4251 9.548 56.1805 9.724 56.8258 10.076C57.4858 10.428 57.9918 10.89 58.3438 11.462V9.724H62.1058V22H58.3438V20.262C57.9771 20.834 57.4638 21.296 56.8038 21.648C56.1585 22 55.4031 22.176 54.5378 22.176C53.5405 22.176 52.6311 21.9193 51.8098 21.406C50.9885 20.878 50.3358 20.1373 49.8518 19.184C49.3825 18.216 49.1478 17.1013 49.1478 15.84ZM58.3438 15.862C58.3438 14.9233 58.0798 14.1827 57.5518 13.64C57.0385 13.0973 56.4078 12.826 55.6598 12.826C54.9118 12.826 54.2738 13.0973 53.7458 13.64C53.2325 14.168 52.9758 14.9013 52.9758 15.84C52.9758 16.7787 53.2325 17.5267 53.7458 18.084C54.2738 18.6267 54.9118 18.898 55.6598 18.898C56.4078 18.898 57.0385 18.6267 57.5518 18.084C58.0798 17.5413 58.3438 16.8007 58.3438 15.862ZM67.1594 8.448C66.4994 8.448 65.9568 8.25733 65.5314 7.876C65.1208 7.48 64.9154 6.996 64.9154 6.424C64.9154 5.83733 65.1208 5.35333 65.5314 4.972C65.9568 4.576 66.4994 4.378 67.1594 4.378C67.8048 4.378 68.3328 4.576 68.7434 4.972C69.1688 5.35333 69.3814 5.83733 69.3814 6.424C69.3814 6.996 69.1688 7.48 68.7434 7.876C68.3328 8.25733 67.8048 8.448 67.1594 8.448ZM69.0294 9.724V22H65.2674V9.724H69.0294ZM75.9577 5.72V22H72.1957V5.72H75.9577ZM91.246 9.724V22H87.484V20.328C87.1027 20.8707 86.582 21.3107 85.922 21.648C85.2767 21.9707 84.558 22.132 83.766 22.132C82.8273 22.132 81.9987 21.9267 81.28 21.516C80.5613 21.0907 80.004 20.482 79.608 19.69C79.212 18.898 79.014 17.9667 79.014 16.896V9.724H82.754V16.39C82.754 17.2113 82.9667 17.8493 83.392 18.304C83.8173 18.7587 84.3893 18.986 85.108 18.986C85.8413 18.986 86.4207 18.7587 86.846 18.304C87.2713 17.8493 87.484 17.2113 87.484 16.39V9.724H91.246ZM99.9762 22.176C98.7736 22.176 97.6882 21.9193 96.7202 21.406C95.7669 20.8927 95.0116 20.1593 94.4542 19.206C93.9116 18.2527 93.6402 17.138 93.6402 15.862C93.6402 14.6007 93.9189 13.4933 94.4762 12.54C95.0336 11.572 95.7962 10.8313 96.7642 10.318C97.7322 9.80467 98.8176 9.548 100.02 9.548C101.223 9.548 102.308 9.80467 103.276 10.318C104.244 10.8313 105.007 11.572 105.564 12.54C106.122 13.4933 106.4 14.6007 106.4 15.862C106.4 17.1233 106.114 18.238 105.542 19.206C104.985 20.1593 104.215 20.8927 103.232 21.406C102.264 21.9193 101.179 22.176 99.9762 22.176ZM99.9762 18.92C100.695 18.92 101.304 18.656 101.802 18.128C102.316 17.6 102.572 16.8447 102.572 15.862C102.572 14.8793 102.323 14.124 101.824 13.596C101.34 13.068 100.739 12.804 100.02 12.804C99.2869 12.804 98.6782 13.068 98.1942 13.596C97.7102 14.1093 97.4682 14.8647 97.4682 15.862C97.4682 16.8447 97.7029 17.6 98.1722 18.128C98.6562 18.656 99.2576 18.92 99.9762 18.92ZM123.332 18.59H116.644L115.412 22H113.3L118.844 6.754H121.154L126.676 22H124.564L123.332 18.59ZM122.76 16.962L119.988 9.218L117.216 16.962H122.76ZM131.534 6.666V22H129.532V6.666H131.534Z"
      fill="black"
    />
    <defs>
      <linearGradient
        id="paint0_linear_288_14883"
        x1="0.505033"
        y1="3.64195"
        x2="25.785"
        y2="28.1446"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

export const StopCreateIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="var(--col_text00)" />
    <rect
      x="10.1053"
      y="10.1055"
      width="11.7895"
      height="11.7895"
      rx="3.36842"
      fill="var(--col_bg04)"
    />
  </svg>
);

export const StopCreateIconNew = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g opacity="0.7">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0003 3.95964C6.6636 3.95964 3.95866 6.66458 3.95866 10.0013C3.95866 13.338 6.6636 16.043 10.0003 16.043C13.337 16.043 16.042 13.338 16.042 10.0013C16.042 6.66458 13.337 3.95964 10.0003 3.95964ZM2.29199 10.0013C2.29199 5.74411 5.74313 2.29297 10.0003 2.29297C14.2575 2.29297 17.7087 5.74411 17.7087 10.0013C17.7087 14.2585 14.2575 17.7096 10.0003 17.7096C5.74313 17.7096 2.29199 14.2585 2.29199 10.0013Z"
        fill="currentColor"
      />
      <path
        d="M7.5 8.33333C7.5 7.8731 7.8731 7.5 8.33333 7.5H11.6667C12.1269 7.5 12.5 7.8731 12.5 8.33333V11.6667C12.5 12.1269 12.1269 12.5 11.6667 12.5H8.33333C7.8731 12.5 7.5 12.1269 7.5 11.6667V8.33333Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const ESCIcon = () => (
  <svg width="32" height="19" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="31" height="18" rx="5.5" stroke="var(--col_text05)" />
    <path
      d="M4.88744 5.432H10.9594V6.284H5.87144V9.152H10.6714V10.004H5.87144V13.148H11.1634V14H4.88744V5.432ZM15.4081 5.264C16.3681 5.264 17.1361 5.48 17.6881 5.924C18.2641 6.38 18.5881 7.064 18.6721 7.964H17.7001C17.5921 7.34 17.3521 6.884 16.9801 6.584C16.5961 6.272 16.0561 6.128 15.3601 6.128C14.7241 6.128 14.2321 6.224 13.8721 6.44C13.4641 6.68 13.2601 7.04 13.2601 7.532C13.2601 7.964 13.5001 8.312 13.9921 8.576C14.2081 8.696 14.7361 8.876 15.5641 9.116C16.6921 9.452 17.4361 9.728 17.7961 9.944C18.5041 10.376 18.8641 10.976 18.8641 11.756C18.8641 12.5 18.5641 13.1 17.9641 13.532C17.3641 13.952 16.5601 14.168 15.5401 14.168C14.5321 14.168 13.7401 13.952 13.1641 13.52C12.4921 13.004 12.1201 12.224 12.0481 11.168H13.0201C13.1041 11.912 13.3681 12.464 13.8001 12.812C14.1961 13.124 14.7721 13.292 15.5401 13.292C16.2361 13.292 16.8121 13.16 17.2441 12.896C17.6761 12.632 17.8921 12.272 17.8921 11.816C17.8921 11.276 17.6041 10.856 17.0401 10.556C16.8001 10.412 16.1881 10.208 15.2281 9.932C14.1961 9.62 13.5361 9.38 13.2601 9.236C12.6001 8.852 12.2761 8.3 12.2761 7.58C12.2761 6.836 12.5881 6.248 13.2241 5.84C13.7881 5.456 14.5201 5.264 15.4081 5.264ZM23.8061 5.264C24.7541 5.264 25.5581 5.516 26.2061 6.02C26.8541 6.524 27.2381 7.208 27.3581 8.06H26.4101C26.2901 7.436 25.9781 6.956 25.4981 6.62C25.0301 6.296 24.4661 6.14 23.7941 6.14C22.7981 6.14 22.0301 6.488 21.4901 7.184C20.9861 7.832 20.7341 8.684 20.7341 9.752C20.7341 10.82 20.9741 11.672 21.4781 12.296C22.0061 12.956 22.7621 13.292 23.7701 13.292C24.4541 13.292 25.0301 13.112 25.5101 12.752C26.0141 12.368 26.3621 11.804 26.5301 11.06H27.4781C27.2861 12.056 26.8421 12.836 26.1341 13.388C25.4741 13.904 24.6821 14.168 23.7701 14.168C22.4381 14.168 21.4181 13.724 20.7101 12.848C20.0621 12.056 19.7501 11.024 19.7501 9.752C19.7501 8.48 20.0741 7.436 20.7341 6.62C21.4541 5.708 22.4861 5.264 23.8061 5.264Z"
      fill="var(--col_text05)"
    />
  </svg>
);

// export const StopMiniIcon = () => (
//   <svg
//     width='36'
//     height='36'
//     viewBox='0 0 36 36'
//     fill='none'
//     xmlns='http://www.w3.org/2000/svg'
//   >
//     <rect
//       width='36'
//       height='36'
//       rx='12'
//       fill='#194132'
//     />
//     <rect
//       x='12.5'
//       y='12.5'
//       width='11'
//       height='11'
//       rx='2'
//       fill='#C3FAAF'
//     />
//   </svg>
// );

export const AnalysingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Tool_code2(1) 1" clipPath="url(#clip0_2772_13845)">
      <path id="Vector" d="M20 0H0V20H20V0Z" fill="white" />
      <path
        id="Vector_2"
        d="M11.2623 7.59008C11.3675 7.19 11.1275 6.78382 10.7264 6.68284C10.3252 6.58186 9.91475 6.82433 9.8096 7.22441L8.44663 12.4099C8.34147 12.81 8.58142 13.2162 8.98258 13.3172C9.38374 13.4181 9.79418 13.1757 9.89934 12.7756L11.2623 7.59008Z"
        fill="#999999"
      />
      <g id="Group 1912054919">
        <path
          id="Vector_3"
          d="M7.78852 8.57566C8.07703 8.28363 8.07704 7.81017 7.78852 7.51814C7.5 7.22611 7.03222 7.22611 6.74371 7.51814L5.00235 9.28068C4.71383 9.57271 4.71383 10.0462 5.00235 10.3382C5.29086 10.6302 5.75864 10.6302 6.04716 10.3382L7.78852 8.57566Z"
          fill="#999999"
        />
        <path
          id="Vector_4"
          d="M6.74382 12.0913C7.03233 12.3833 7.50011 12.3833 7.78863 12.0913C8.07715 11.7992 8.07715 11.3258 7.78863 11.0337L6.04727 9.2712C5.75875 8.97917 5.29098 8.97917 5.00246 9.2712C4.71394 9.56322 4.71394 10.0367 5.00246 10.3287L6.74382 12.0913Z"
          fill="#999999"
        />
      </g>
      <g id="Group 1912054920">
        <path
          id="Vector_5"
          d="M12.2105 8.57566C11.922 8.28363 11.922 7.81017 12.2105 7.51814C12.499 7.22611 12.9668 7.22611 13.2553 7.51814L14.9967 9.28068C15.2852 9.57271 15.2852 10.0462 14.9967 10.3382C14.7082 10.6302 14.2404 10.6302 13.9519 10.3382L12.2105 8.57566Z"
          fill="#999999"
        />
        <path
          id="Vector_6"
          d="M13.2552 12.0913C12.9667 12.3833 12.4989 12.3833 12.2104 12.0913C11.9219 11.7992 11.9219 11.3258 12.2104 11.0337L13.9518 9.2712C14.2403 8.97917 14.708 8.97917 14.9966 9.2712C15.2851 9.56322 15.2851 10.0367 14.9966 10.3287L13.2552 12.0913Z"
          fill="#999999"
        />
      </g>
      <path
        id="Vector_7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.08325 5.41675C2.08325 4.03604 3.20254 2.91675 4.58325 2.91675H15.4166C16.7973 2.91675 17.9166 4.03604 17.9166 5.41675V14.5835C17.9166 15.9642 16.7973 17.0835 15.4166 17.0835H4.58325C3.20254 17.0835 2.08325 15.9642 2.08325 14.5835V5.41675ZM4.58325 4.58341C4.12302 4.58341 3.74992 4.95651 3.74992 5.41675V14.5835C3.74992 15.0437 4.12302 15.4168 4.58325 15.4168H15.4166C15.8768 15.4168 16.2499 15.0437 16.2499 14.5835V5.41675C16.2499 4.95651 15.8768 4.58341 15.4166 4.58341H4.58325Z"
        fill="#999999"
      />
    </g>
    <defs>
      <clipPath id="clip0_2772_13845">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AnalyseErrorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#229;&#174;&#140;&#230;&#136;&#144;icon">
      <circle id="Ellipse 1550" cx="9" cy="9" r="6.825" stroke="#999999" strokeWidth="1.35" />
      <g id="Group 1312318810">
        <path
          id="Line 2"
          d="M9 5.625L9 10.1249"
          stroke="#999999"
          strokeWidth="1.35"
          strokeLinecap="round"
        />
        <path
          id="Ellipse 1570"
          d="M9.67495 12.6562C9.67495 13.029 9.37274 13.3312 8.99995 13.3312C8.62716 13.3312 8.32495 13.029 8.32495 12.6562C8.32495 12.2834 8.62716 11.9812 8.99995 11.9812C9.37274 11.9812 9.67495 12.2834 9.67495 12.6562Z"
          fill="#999999"
        />
      </g>
    </g>
  </svg>
);

export const AnalyseFinishedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 2036081267">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.15 10C16.15 13.3966 13.3966 16.15 10 16.15C6.60345 16.15 3.85 13.3966 3.85 10C3.85 6.60345 6.60345 3.85 10 3.85C13.3966 3.85 16.15 6.60345 16.15 10ZM17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM8.85628 12.2717C9.11765 12.5331 9.54002 12.5353 9.80408 12.2783L9.81827 12.2645L13.1063 8.97645C13.3699 8.71285 13.3699 8.28546 13.1063 8.02186C12.8427 7.75826 12.4153 7.75826 12.1517 8.02186L9.33352 10.8401L7.84826 9.35494C7.58468 9.09139 7.15737 9.0914 6.89381 9.35496C6.63024 9.61854 6.63025 10.0459 6.89383 10.3094L8.85628 12.2717Z"
        fill="#14151A"
      />
    </g>
  </svg>
);

export const AnalyseArrow = ({
  fillName = '#14151A',
  className,
}: {
  fillName?: string;
  className?: string;
}) => (
  <svg
    className={className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 1912054802">
      <path
        id="Vector 3262 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53033 4.21967C9.82322 4.51256 9.82322 4.98744 9.53033 5.28033L6.53033 8.28033C6.23744 8.57322 5.76257 8.57322 5.46967 8.28033L2.46967 5.28036C2.17678 4.98746 2.17678 4.51259 2.46967 4.2197C2.76256 3.9268 3.23743 3.9268 3.53033 4.21969L6 6.68934L8.46967 4.21967C8.76256 3.92678 9.23744 3.92678 9.53033 4.21967Z"
        fill={fillName}
      />
    </g>
  </svg>
);

export const WXScanSucceedIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon/Tool_selected">
      <path
        id="&#229;&#156;&#134;"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
        fill="#08AA5D"
      />
      <path
        id="&#231;&#171;&#150;"
        d="M16.4143 21.95C17.1954 21.169 18.4617 21.169 19.2427 21.95L24.1928 26.8995C24.9739 27.6806 24.9739 28.947 24.1928 29.728C23.4118 30.5091 22.1455 30.5091 21.3645 29.7281L16.4144 24.7786C15.6333 23.9975 15.6333 22.7311 16.4143 21.95Z"
        fill="white"
      />
      <path
        id="&#231;&#171;&#150;_2"
        d="M32.6778 18.4143C33.4589 19.1953 33.4589 20.4617 32.6778 21.2427L24.1925 29.728C23.4115 30.509 22.1452 30.509 21.3641 29.728C20.5831 28.9469 20.5831 27.6806 21.3641 26.8996L29.8494 18.4143C30.6305 17.6332 31.8968 17.6332 32.6778 18.4143Z"
        fill="white"
      />
    </g>
  </svg>
);

export const ToastWarningIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_768_5156)">
      <path
        d="M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM13 17.5H11V15.5H13V17.5ZM13 13.5H11V7.5H13V13.5Z"
        fill="#FF8C21"
      />
    </g>
    <defs>
      <clipPath id="clip0_768_5156">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ToastErrorIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_268_9416)">
      <path
        d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
        fill="#F04248"
      />
    </g>
    <defs>
      <clipPath id="clip0_268_9416">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ToastSuccessIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_268_9429)">
      <path
        d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
        fill="#00B42A"
      />
    </g>
    <defs>
      <clipPath id="clip0_268_9429">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ToastInfoIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5ZM11 7.5L13 7.5L13 9.5L11 9.5L11 7.5ZM11 11.5L13 11.5L13 17.5L11 17.5L11 11.5Z"
      fill="#355491"
    />
  </svg>
);
